import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appDynamicColumn]'
})
export class DynamicColumnDirective {

  constructor(public viewContainerRef: ViewContainerRef) {}

}
